/*
* Broadcast Theme - H&H Brand Custom JavaScript
* v2026-07-21.1 (remove JS logo-placeholder hack — replaced by the Liquid
*   fallback in snippets/product-image.liquid; version bump busts CDN cache)
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ============================================================================
     BROADCAST THEME MOBILE MENU FIX
     Fixes hamburger menu responsiveness on mobile devices
  ============================================================================== */

  document.addEventListener('DOMContentLoaded', function() {
    // Broadcast uses specific selectors for mobile menu
    const mobileMenuTriggers = document.querySelectorAll('.js-drawer-open-nav, .mobile-nav__toggle, .header__mobile-nav-toggle, [data-drawer-trigger="nav"], .navmobile-button');
    const mobileDrawer = document.querySelector('.drawer--nav, .mobile-nav__drawer, #NavDrawer, [data-drawer="nav"]');
    const closeButtons = document.querySelectorAll('.drawer__close, .js-drawer-close');
    const overlay = document.querySelector('.drawer__overlay, .mobile-nav__overlay');

    // Function to open mobile menu
    function openMobileMenu() {
      if (mobileDrawer) {
        mobileDrawer.classList.add('drawer--active', 'drawer--visible');
        document.body.classList.add('drawer--open', 'overflow-hidden');

        // Broadcast theme may use aria attributes
        mobileDrawer.setAttribute('aria-hidden', 'false');

        // Show overlay if exists
        if (overlay) {
          overlay.classList.add('drawer__overlay--visible');
          overlay.style.display = 'block';
        }
      }
    }

    // Function to close mobile menu
    function closeMobileMenu() {
      if (mobileDrawer) {
        mobileDrawer.classList.remove('drawer--active', 'drawer--visible');
        document.body.classList.remove('drawer--open', 'overflow-hidden');

        // Update aria attributes
        mobileDrawer.setAttribute('aria-hidden', 'true');

        // Hide overlay
        if (overlay) {
          overlay.classList.remove('drawer__overlay--visible');
          setTimeout(() => {
            overlay.style.display = 'none';
          }, 300);
        }

        // Reset hamburger icon animation
        mobileMenuTriggers.forEach(trigger => {
          trigger.classList.remove('is-active');
        });
      }
    }

    // Add click handlers to all menu triggers
    mobileMenuTriggers.forEach(trigger => {
      // Remove existing listeners by cloning
      const newTrigger = trigger.cloneNode(true);
      trigger.parentNode.replaceChild(newTrigger, trigger);

      // Add new click handler
      newTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Toggle hamburger icon animation
        this.classList.toggle('is-active');

        // Open/close drawer based on current state
        if (mobileDrawer && mobileDrawer.classList.contains('drawer--active')) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });

      // Ensure trigger is clickable
      newTrigger.style.cursor = 'pointer';
      newTrigger.style.pointerEvents = 'auto';
    });

    // Add close handlers
    closeButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        closeMobileMenu();
      });
    });

    // Close on overlay click
    if (overlay) {
      overlay.addEventListener('click', closeMobileMenu);
    }

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('drawer--active')) {
        closeMobileMenu();
      }
    });
  });

  /* ============================================================================
     HAMBURGER ICON ANIMATION
     Animates hamburger lines on click
  ============================================================================== */

  document.addEventListener('DOMContentLoaded', function() {
    const hamburgerIcons = document.querySelectorAll('.header__mobile-nav-toggle, .mobile-nav__icon, .navmobile-button');

    hamburgerIcons.forEach(icon => {
      icon.addEventListener('click', function() {
        this.classList.toggle('is-active');

        // Animate hamburger lines if they exist
        const lines = this.querySelectorAll('.icon-line');
        if (lines.length) {
          lines[0]?.classList.toggle('icon-line--top');
          lines[1]?.classList.toggle('icon-line--middle');
          lines[2]?.classList.toggle('icon-line--bottom');
        }
      });
    });
  });

  /* ============================================================================
     (removed 2026-07-21) LOGO AS DEFAULT PRODUCT PLACEHOLDER — the JS approach
     swapped the logo into any product image that had not finished loading at
     DOMContentLoaded, hijacking real lazy/slow images. Replaced by the Liquid
     fallback in snippets/product-image.liquid (+ .hh-noimg-logo CSS).
  ============================================================================== */

  /* ============================================================================
     MOBILE MENU ACCORDION
     Expand/collapse handling for nested links in the mobile drawer menu.
     The markup (toggle button + hidden panel) is rendered by
     snippets/nav-item-mobile.liquid and styled in theme.css; this is the
     behavior half. Below 990px panels start hidden and toggle open;
     at 990px and up panels render expanded and toggles are hidden by CSS.
  ============================================================================== */

  (function mobileMenuAccordion() {
    const selectors = {
      drawerMenu: '.drawer__main-menu',
      accordionItem: '[data-mobile-accordion-item]',
      accordionToggle: '[data-mobile-accordion-toggle]',
      accordionPanel: '[data-mobile-accordion-panel]',
      accordionLabel: '[data-mobile-accordion-label]',
    };

    const openClass = 'is-open';
    const desktopMedia = window.matchMedia('(min-width: 990px)');

    const setAccordionState = (item, expand = false) => {
      const toggle = item.querySelector(selectors.accordionToggle);
      const panel = item.querySelector(selectors.accordionPanel);

      if (!panel || !toggle) return;

      toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
      panel.hidden = desktopMedia.matches ? false : !expand;
      item.classList.toggle(openClass, expand);
    };

    const closeSiblingAccordions = (item) => {
      const siblings = item.parentElement?.querySelectorAll(selectors.accordionItem);
      siblings?.forEach((sibling) => {
        if (sibling !== item) {
          setAccordionState(sibling, false);
        }
      });
    };

    const toggleItem = (item) => {
      const isOpen = item.classList.contains(openClass);
      if (!isOpen) {
        closeSiblingAccordions(item);
      }
      setAccordionState(item, !isOpen);
    };

    const handleAccordionToggle = (event) => {
      const item = event.currentTarget.closest(selectors.accordionItem);
      if (!item || desktopMedia.matches) return;
      toggleItem(item);
    };

    const handleAccordionLabel = (event) => {
      const item = event.currentTarget.closest(selectors.accordionItem);
      if (!item || desktopMedia.matches) return;
      event.preventDefault();
      toggleItem(item);
    };

    const bindMobileAccordion = (scope = document) => {
      if (!scope || !scope.querySelectorAll) return;

      scope.querySelectorAll(selectors.drawerMenu).forEach((menu) => {
        menu.querySelectorAll(selectors.accordionToggle).forEach((toggle) => {
          if (toggle.dataset.mobileAccordionBound) return;
          toggle.dataset.mobileAccordionBound = 'true';
          toggle.addEventListener('click', handleAccordionToggle);
        });

        menu.querySelectorAll(selectors.accordionLabel).forEach((label) => {
          if (label.dataset.mobileAccordionBound) return;
          label.dataset.mobileAccordionBound = 'true';
          label.addEventListener('click', handleAccordionLabel);
        });

        menu.querySelectorAll(selectors.accordionItem).forEach((item) => {
          const panel = item.querySelector(selectors.accordionPanel);
          if (panel) {
            panel.hidden = !desktopMedia.matches;
          }
        });
      });
    };

    const syncAccordionToBreakpoint = () => {
      document.querySelectorAll(selectors.accordionItem).forEach((item) => {
        const panel = item.querySelector(selectors.accordionPanel);
        const toggle = item.querySelector(selectors.accordionToggle);
        if (!panel || !toggle) return;

        if (desktopMedia.matches) {
          panel.hidden = false;
          toggle.setAttribute('aria-expanded', item.classList.contains(openClass) ? 'true' : 'false');
        } else if (!item.classList.contains(openClass)) {
          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    };

    desktopMedia.addEventListener('change', syncAccordionToBreakpoint);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector(selectors.drawerMenu)) {
        bindMobileAccordion(event.target);
        syncAccordionToBreakpoint();
      }
    });

    document.addEventListener('theme:drawer:open', (event) => {
      if (event.target?.closest && event.target.closest('mobile-menu')) {
        bindMobileAccordion(event.target.closest('mobile-menu'));
        syncAccordionToBreakpoint();
      }
    });

    const init = () => {
      bindMobileAccordion();
      syncAccordionToBreakpoint();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
